import {Box} from '@mui/system';
import {
  PolygonLayer,
  LayerEvent,
  MapScene,
  Control,
  Popup,
  ColorComponent,
  LineLayer
} from '@antv/l7-react';
import React, {useEffect, useState} from 'react';
import {usePapaParse} from 'react-papaparse';
import DownloadButton from '../Common/DownloadButton';
import ModalTrigger from '../Common/ModalTrigger';
import classes from '../../Style/ReportingCountry.scss';
import MapTooltip from "./MapTooltip";

const CountryOfOriginMap = (props) => {
  const samplesFilter = props.samplesFilter;
  const negatives = samplesFilter.indexOf('Difference') > -1;

  const [hovered, setHovered] = useState(undefined);
  const csv = props.csv;
  const {readString} = usePapaParse();
  const json = props.json;

  const initialState = {
    json: null,
    conv: null
  };
  const [data, setData] = useState(initialState);
  const [max, setMax] = useState(undefined);
  const [min, setMin] = useState(undefined);
  const [unknown, setUnknown] = useState(undefined);

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        json.features.map((j) => {
          const found = results.data.find(
            (d) =>
              d['Country of origin MOPER recoded (LAST) DESC'] ===
              j.properties['NAME_ENGL']
          );
          if (found) {
            j.properties = {...j.properties, sum: found[samplesFilter]};
          } else {
            j.properties = {...j.properties, sum: 0};
          }
          return j;


        });
        if (chart) {
          chart.layer.setData(json);
        }
        setMax(
          Math.max(
            ...results.data.map((f) => {
              if (
                f['Pest Origin ID'] === null ||
                f['Pest Origin ID'] === 'Total' ||
                f['Pest Origin ID'] === 'Unknown'
              ) {
                return 0;
              }

              return f[samplesFilter] ? f[samplesFilter] : 0;
            })
          )
        );
        setMin(
          Math.min(
            ...results.data.map((f) => {
              if (
                f['Pest Origin ID'] === null ||
                f['Pest Origin ID'] === 'Total' ||
                f['Pest Origin ID'] === 'Unknown'
              ) {
                return 0;
              }

              return f[samplesFilter] ? f[samplesFilter] : 0;
            })
          )
        );
        let sumUnkown = 0;
        setUnknown(
          results.data.forEach((f) => {
            if (f['Pest Origin ID'] === 'Unknown') {
              sumUnkown += f[samplesFilter] ? f[samplesFilter] : 0;
            }
          })
        );
        setUnknown(sumUnkown);
        setData({json: json, conv: results.data});
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log('Error while parsing:', error, file);
      }
    });
  };

  useEffect(() => {
    handleReadString();
  }, [samplesFilter]);

  const [chart, setChart] = useState(undefined);

  const handleLoaded = (scene, layer) => {
    setChart({scene, layer});
  };

  const [canvas, setCanvas] = useState(undefined);

  const getTooltipContent = (country) => {
    const found = data.conv.find(
      (d) => d['Country of origin MOPER recoded (LAST) DESC'] === country
    );
    if (!found) {
      return <p>{ country }</p>;
    }
    return (
      <div className='tooltipWrapper' style={ {wordWrap: 'break-word'} }>
        { samplesFilter && (
          <>
						<span id='countryOfOriginTooltip'>
							<b>
								Country of origin:{ ' ' }
                { found['Country of origin MOPER recoded (LAST) DESC'] }
							</b>
						</span>
            <br></br>
            <span
              id='countryOfOriginTooltip2'
              style={ {
                color: '#22294D',
                paddingBottom: '0px',
                fontSize: '12px'
              } }
            >
							{ found[samplesFilter] === null
                ? samplesFilter + ': ' + '-'
                : samplesFilter + ': ' + found[samplesFilter].toLocaleString() }{ ' ' }
              { samplesFilter === 'Number of samples' ||
              samplesFilter === 'Number of samples per 100k inhabitants'
                ? ''
                : '%' }
						</span>
          </>
        ) }
      </div>
    );
  };

  let colors = [
    '#fff',
    '#D0D1D5',
    '#BDBFC6',
    '#9699A7',
    '#6F7389',
    '#484D6A',
    '#22294D'
  ];
  if (negatives) {
    colors = [
      '#fff',
      '#f9b11233',
      '#ffe7a6',
      '#f9b11299',
      '#ffcd42',
      '#ffc629',
      '#F9B112',
      '#D0D1D5',
      '#BDBFC6',
      '#9699A7',
      '#9699A7',
      '#484D6A',
      '#22294D'
    ];
  }
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }

    window.addEventListener('resize', handleResize);
    return (_) => {
      window.removeEventListener('resize', handleResize);
    };
  });
  useEffect(() => {
    const canvases = document.getElementsByClassName('l7-marker-container');
    for (let i = 0; i < canvases.length; i++) {
      canvases[i].onwheel = function (event) {
        event.stopPropagation();
      };
    }
  });
  const createLegendLabel = (reduction, isUnknown, isNegative) => {
    if (isUnknown) {
      if (unknown) {
        return (samplesFilter.indexOf('Difference') > -1 ||
          samplesFilter.indexOf('Rate')) > -1
          ? Math.round(unknown * reduction) + '%'
          : Math.round(unknown * reduction);
      }
    } else if (isNegative) {
      if (min) {
        return (samplesFilter.indexOf('Difference') > -1 ||
          samplesFilter.indexOf('Rate')) > -1
          ? Math.round(min * reduction) + '%'
          : Math.round(min * reduction);
      }
    } else {
      if (max) {
        return (samplesFilter.indexOf('Difference') > -1 ||
          samplesFilter.indexOf('Rate')) > -1
          ? Math.round(max * reduction) + '%'
          : Math.round(max * reduction);
      }
    }
    return '';
  };

  return (
    <Box>
      <Box>
        <Box display='flex' justifyContent='flex-end'>
          <Box display='flex' flexDirection='row'>
            <div
              className='legend-nodata'
              style={ {
                width: '20%',
                marginRight: '10px',
              } }>
              <ColorComponent
                items={ [
                  {title: 'No Data', color: '#fff'}] }/>
            </div>

            { max && !negatives && (

              <div
                className='legent-title'
                style={ {
                  fontFamily: 'Roboto Condensed, sans-serif',
                  fontSize: isMobile ? '12px' : '15px',
                  width: isMobile ? '250px' : '300px',
                  float: 'right'

                } }
              >

                <ColorComponent
                  items={ [
                    {title: '0', color: '#D0D1D5'},
                    {
                      title: createLegendLabel(0.1).toLocaleString(),
                      color: '#BDBFC6'
                    },
                    {
                      title: createLegendLabel(0.3).toLocaleString(),
                      color: '#9699A7'
                    },
                    {
                      title: createLegendLabel(0.5).toLocaleString(),
                      color: '#6F7389'
                    },
                    {
                      title: createLegendLabel(0.6).toLocaleString(),
                      color: '#484D6A'
                    },
                    {
                      title: createLegendLabel(1).toLocaleString(),
                      color: '#22294D'
                    }
                  ] }
                />
              </div>
            ) }

            { negatives && min && (
              <div
                className='legent-title'
                style={ {
                  fontFamily: 'Roboto Condensed, sans-serif',
                  fontSize: isMobile ? '12px' : '15px',
                  width: isMobile ? '250px' : '300px',
                  float: 'right'
                } }
              >
                <ColorComponent
                  items={ [
                    {
                      title: createLegendLabel(1, false, true).toLocaleString(),
                      color: '#F9B112'
                    },
                    {
                      title: createLegendLabel(
                        0.6,
                        false,
                        true
                      ).toLocaleString(),
                      color: '#f9b11299'
                    },
                    {
                      title: createLegendLabel(
                        0.2,
                        false,
                        true
                      ).toLocaleString(),
                      color: '#f9b11233'
                    },
                    {title: 0, color: '#D0D1D5'},
                    {
                      title: createLegendLabel(0.2).toLocaleString(),
                      color: '#6F7389'
                    },
                    {
                      title: createLegendLabel(0.6).toLocaleString(),
                      color: '#484D6A'
                    },
                    {
                      title: createLegendLabel(1).toLocaleString(),
                      color: '#22294D'
                    }
                  ] }
                />
              </div>
            ) }
          </Box>
          <Box display='flex' pl='10px'>
            <DownloadButton
              isMap
              canvas={ canvas }
              fileName='Map'
              csv={ data.conv }
            />
            <Box pl='10px'>
              <ModalTrigger
                style={ {color: '#22294D', cursor: 'pointer'} }
                text="Kosovo Disclaimer"
              />
            </Box>
          </Box>
        </Box>
        { data.json && (
          <MapScene
            onSceneLoaded={ (scene) => {
              setCanvas(scene);
            } }
            autoFit
            map={ {
              pitch: 0,
              style: 'blank',
              zoom: 0,
              minZoom: 0,
              maxZoom: 4,
              center: [112, 30],
              renderer: 'svg'
            } }
            style={ {
              height: '500px',
              position: 'relative'
            } }
          >
            <PolygonLayer
              onLayerLoaded={ (layer, scene) => {
                handleLoaded(scene, layer);
              } }
              key={ 1 }
              zIndex={ 1 }
              source={ {
                data: data.json
              } }
              color={ {
                field: 'sum',
                values: (d) => {
                  if (negatives) {
                    if (d === 0 || d === null) {
                      return colors[0];
                    } else if (d < 0 && d >= min * 0.1) {
                      return colors[1];
                    } else if (d < min * 0.1 && d >= min * 0.3) {
                      return colors[3];
                    } else if (d < min * 0.3 && d >= min * 0.5) {
                      return colors[4];
                    } else if (d < min * 0.5 && d >= min * 0.6) {
                      return colors[5];
                    } else if (d < min * 0.6 && d >= min) {
                      return colors[6];
                    } else if (d > 0 && d <= max * 0.1) {
                      return colors[7];
                    } else if (d > max * 0.1 && d <= max * 0.3) {
                      return colors[8];
                    } else if (d > max * 0.3 && d <= max * 0.5) {
                      return colors[9];
                    } else if (d > max * 0.5 && d <= max * 0.6) {
                      return colors[10];
                    } else {
                      return colors[11];
                    }
                  } else {
                    if (d === 0 || d === null) {
                      return colors[0];
                    } else if (d > 0 && d <= max * 0.1) {
                      return colors[1];
                    } else if (d > max * 0.1 && d <= max * 0.3) {
                      return colors[3];
                    } else if (d > max * 0.3 && d <= max * 0.5) {
                      return colors[4];
                    } else if (d > max * 0.5 && d <= max * 0.6) {
                      return colors[5];
                    } else {
                      return colors[6];
                    }
                  }
                }
              } }
              options={ {
                autoFit: true
              } }
              size={ {
                values: 1
              } }
              shape={ {values: 'fill'} }
              active={ {
                option: {
                  color: '#C6C2C2'
                }
              } }
              select={ false }
            >
              <LayerEvent
                type='mouseenter'
                handler={ (e) => {
                  setHovered(e);
                } }
              />
              <LayerEvent
                type='mouseout'
                handler={ (e) => {
                  setHovered(undefined);
                } }
              />
            </PolygonLayer>

            <PolygonLayer
              key={ 2 }
              source={ {
                data: data.json
              } }
              size={ {
                values: 0.5
              } }
              color={ {
                values: '#C6C2C2'
              } }
              shape={ {
                values: 'line'
              } }
              style={ {
                opacity: 0.5
              } }
              zIndex={ 10 }
            />
            <LineLayer
              key={ 5 }
              zIndex={ 25 }
              source={ {
                data: {
                  type: 'FeatureCollection',
                  features: data.json.features.filter(
                    (feature) => feature.properties.ISO3_CODE === 'XKX-SRB'
                  )
                }
              } }
              size={ {values: 0.8} }
              color={ {values: "#d0d1d5"} }
              shape={ {values: 'line'} }
              style={ {
                lineType: 'dash',
                dashArray: [2, 2],
                opacity: 0.9
              } }
            />
            <LineLayer
              key={ 5 }
              zIndex={ 25 }
              source={ {
                data: {
                  type: 'FeatureCollection',
                  features: data.json.features.filter(
                    (feature) => feature.properties.ISO3_CODE === 'PSE'
                  )
                }
              } }
              size={ {values: 0.8} }
              color={ {values: "#d0d1d5"} }
              shape={ {values: 'line'} }
              style={ {
                lineType: 'dash',
                dashArray: [2, 2],
                opacity: 0.9
              } }
            />
            { hovered &&
            samplesFilter &&
            data.conv.find(
              (d) =>
                d['Country of origin MOPER recoded (LAST) DESC'] ===
                hovered.feature.properties.NAME_ENGL
            ) && (
              <MapTooltip>
                { getTooltipContent(hovered.feature.properties.NAME_ENGL) }
              </MapTooltip>
            ) }

            <Control type='scale' position='bottomright'/>
            <Control type='zoom' position='bottomright'/>
          </MapScene>
        ) }
        { unknown && (
          <div
            style={ {
              fontFamily: 'Roboto Condensed, sans-serif',
              width: '150px'
            } }
            className='unknown-legend-wrapper'
          >
            <ColorComponent
              items={ [
                {
                  title:
                    'Unknown: ' + createLegendLabel(1, true).toLocaleString(),
                  color: '#9D3140'
                }
              ] }
            />
          </div>
        ) }
      </Box>
    </Box>
  );
};

export default CountryOfOriginMap;
